import * as React from "react";
const SvgFiRrBroom = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-broom_svg__a)">
      <path
        fill="#062147"
        d="M23.715 2.285a1.013 1.013 0 0 0-1.43 0l-4.764 4.764-.32-.313a5.01 5.01 0 0 0-6.429-.479 16.6 16.6 0 0 1-4.548 2.428l-2.074.608a5.04 5.04 0 0 0-3.113 2.635A4.97 4.97 0 0 0 .9 15.947a12.95 12.95 0 0 0 12.112 8.064h.924c.207 0 .409-.064.578-.182a15.29 15.29 0 0 0 6.71-10.209 5.03 5.03 0 0 0-1.453-4.374l-.8-.784 4.747-4.747a1.013 1.013 0 0 0-.003-1.43m-10.107 19.7h-.6a11.3 11.3 0 0 1-4.308-.847l.011-.006a11.55 11.55 0 0 0 4.351-3.8l.518-.761a1.01 1.01 0 1 0-1.67-1.138l-.518.761A9.54 9.54 0 0 1 7.8 19.327l-1.251.63c-1-.704-1.874-1.573-2.583-2.57a11.6 11.6 0 0 0 4.377-2.664 1.011 1.011 0 1 0-1.414-1.446 9.6 9.6 0 0 1-3.98 2.32c-.061-.135-.127-.267-.182-.406a2.9 2.9 0 0 1 .085-2.381 3.02 3.02 0 0 1 1.864-1.578l2.073-.608a15.4 15.4 0 0 0 3.426-1.588l7.915 7.712a14.2 14.2 0 0 1-4.522 5.241zm5.62-8.683q-.115.703-.309 1.387L11.948 7.9a3 3 0 0 1 1.755-.566 2.97 2.97 0 0 1 2.084.849l2.569 2.509a3.01 3.01 0 0 1 .872 2.614z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-broom_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBroom;
